'use client';

import dynamic from 'next/dynamic';

const FacebookPixelClient = dynamic(() => import('@/app/components/inits/FacebookPixelInit'), { ssr: false });

export default function LazyInit() {
  return <>
    <FacebookPixelClient />
  </>;
}
